/* eslint-disable no-bitwise */

export const getStatus = (arr, item, isPayment) => {
  const obj = {};
  switch (arr) {
    case 1:
      obj.text = 'Pendente';
      obj.status = 'pending';
      break;
    case 3:
      obj.text = isPayment ? 'Recusado' : 'Reprovado';
      obj.status = 'refused';
      break;
    case 4:
      obj.text = 'Em análise';
      obj.status = 'warn';
      break;
    case 5:
      obj.text = 'Enviado para faturamento';
      obj.status = 'approved';
      break;
    case 2:
      obj.text = isPayment ? 'Realizado' : 'Aprovado';
      obj.status = 'approved';
      break;
    default:
      obj.text = 'Pendente';
      obj.status = 'pending';
  }
  return obj[item];
};
